module.exports = __webpack_public_path__ + "img/brand.ee28bacc.png";